import * as React from "react";
import { Lightbox } from "../../../react-core/Html/Components/Lightbox";

interface IDeleteLightboxProps {
    onClose: VoidFunction;
    onDelete: VoidFunction;
    content: JSX.Element;
}

export const DeleteLightbox = (props: IDeleteLightboxProps) => {
    return (
        <Lightbox
            cssWrapper="is-default-lightbox is-delete-lightbox"
            show={true}
            onClose={() => props.onClose()}
            title="Delete filter"
        >
                           {props.content}
                           
            <div className="row row-center">
                          
                <div className="col-auto">
                    <button type="button" className="btn secondary" onClick={() => props.onClose()}>
                        Cancel
                    </button>
                                       
                </div>
                <div className="col-auto">
                                           
                    <button
                        type="button"
                        className="btn primary"
                        onClick={() => {
                            props.onClose();
                            props.onDelete();
                        }}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </Lightbox>
    );
};
